import { NewSpaceStepper } from '@/pages/workgroup/form/Stepper';
import { Outlet } from 'react-router-dom';
import { Container, ChildPage } from '@/pages/workgroup/form/StyledComponent';
import SupportDrawer from '@/pages/home/support/SupportDrawer';
import { supportOpenAtom } from '@/pages/home/support/atom';
import { useAtom } from 'jotai';

export default function SpaceLayout() {
  const [isSupportOpen, setIsSupportOpen] = useAtom(supportOpenAtom);

  return (
    <>
      <Container>
        <NewSpaceStepper />
        <ChildPage>
          <Outlet />
        </ChildPage>
      </Container>
      <SupportDrawer isShow={isSupportOpen} onClose={() => setIsSupportOpen(false)} />
    </>
  );
}
